import React, { Component } from "react";
import Breadcrumbs from "react-router-dynamic-breadcrumbs";

import i18n from "i18n-react";
import { storageKeys } from "settings";
import {
  APIHandler,
  DataHandler,
  StorageHandler,
  FavoriteLink,
  ContentHeader
} from "C4";

// const crumbRoutes = {
//   '/main': 'Home',
//   '/main/favorites': 'Favorites',
// };

export default class FavoriteView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      favorites: []
    };
  }

  componentWillMount() {
    this.setFavorites();
  }

  setFavorites() {
    return DataHandler.matchAppId().then(appId =>
      StorageHandler.load(storageKeys.user).then(user =>
        APIHandler.getFavorite(appId, user.response.email, {
          message: "Called from FavoriteView.js"
        }).then(favorites => {
          StorageHandler.save(storageKeys.favorites, favorites);
          const favoriteArray = [];
          const favoriteContent = [];
          favorites.data.forEach(el => {
            favoriteContent.push(el);
          });
          APIHandler.getFavoriteContent(favoriteContent).then(res => {
            res.pages.forEach((info, index) => {
              const key = index;
              favoriteArray.push(
                <FavoriteLink
                  info={info}
                  favorites={favorites}
                  contentInfo={favoriteContent[key]}
                  key={`fav_${key}`}
                />
              );
            });
            this.setState({ favorites: favoriteArray });
          });
        })
      )
    );
  }

  render() {
    return (
      <div className="contentContainer">
        {/* <Breadcrumbs
          mappedRoutes={crumbRoutes}
          WrapperComponent={props => <ul className="breadcrumb__List">{props.children}</ul>}
          LinkComponent={props => <li className="breadcrumb__item">{props.children}<span className="breadcrumb__separator">&#62;</span></li>}
          ActiveLinkComponent={props => <li className="breadcrumb__item--active">{props.children}</li>}
        /> */}
        <ContentHeader
          header={i18n.translate("nav.favorites")}
          subtitle={i18n.translate("pageDescriptions.favorites")}
        />
        <div className="favorite__Container">
          {this.state.favorites.length === 0 && (
            <p className="subtitle">{i18n.translate("general.noFavorites")}</p>
          )}
          <div className="favorite__Grid">{this.state.favorites}</div>
        </div>
      </div>
    );
  }
}
